import styled from 'styled-components';

import BadgeComponent from '../Badge';

export const Badge = styled(BadgeComponent)`
  padding: 5px 17px !important;
`;
